import "../src/Components/Errors/styles.less";

import { Button, Col, Row, Typography } from "antd";

import { PageLayout } from "../src/Components/Layout/web";
import React from "react";
import { withApollo } from "../lib/apollo3";
import { withContext } from "../lib/context";
import { withAuth } from "../lib/auth";
import { withGlobalComponents } from "../shared-components/ViewFragments/GlobalComponents/web";
import { withTranslation } from "../shared-components/i18n";
import { useTheme } from "../shared-components/Styles/ThemeHook";


import { ImagenOptimizada } from "shared-components/Components/Image/_new_web";
import Link from "next/link";

const { Title } = Typography;

const ErrorPage = ({ statusCode }) => {
	const { theme } = useTheme();

	const PageMessage: string = statusCode === 404 ? "Página no encontrada" : "Parece que algo salió mal";

	return (
		<PageLayout classContainer="error-page" withFooter={false}>
			<Row gutter={[0, 2 * theme.spacing.xxlSpacing]}>
				<Col span={24}>
					<div className="container">
						<div className="logo">
							<ImagenOptimizada
								src={theme.images.favicon}
								alt="Logo"
								className="logo_image"
								width={140}
								height={50}
							/>
						</div>
						<br />

						<Title level={2}>
							{"Oops!"}{" "}
							<span className="text-color">
								{"error"} {statusCode}
							</span>
						</Title>

						<Title level={1}>{PageMessage}</Title>

						<div className="text-center">
							<Link href="/home" as="/">
								<Button type="primary"> {"Volver"} </Button>
							</Link>
						</div>
					</div>
				</Col>
			</Row>
		</PageLayout>
	);
};

export default withApollo(
	withContext(withTranslation(withAuth(withGlobalComponents(ErrorPage))), {
		withDummyContext: false,
		withFiltersContext: false,
		withConfigContext: true,
		withThemeContext: true,
	})
);
